
export const STORAGE_KEYS = {
  FASTING_SESSIONS: 'fasting_sessions',
  WALK_ENTRIES: 'walk_entries',
  JOURNAL_ENTRIES: 'journal_entries',
  FOOD_ENTRIES: 'food_entries',
  HEALTH_ENTRIES: 'health_entries',
  WATER_ENTRIES: 'water_entries',
  ACTIVE_FASTING: 'active_fasting',
  SETTINGS: 'settings',
  FAVORITE_FOODS: 'favorite_foods',
  USER_SETTINGS: 'user_settings'
};

// Add table mapping for Supabase tables
export const STORAGE_KEY_TO_TABLE_MAP = {
  [STORAGE_KEYS.FASTING_SESSIONS]: 'fasting_sessions',
  [STORAGE_KEYS.WALK_ENTRIES]: 'walking_entries', // Fix: was walk_entries, should be walking_entries
  [STORAGE_KEYS.JOURNAL_ENTRIES]: 'journal_entries',
  [STORAGE_KEYS.FOOD_ENTRIES]: 'food_entries',
  [STORAGE_KEYS.HEALTH_ENTRIES]: 'health_entries',
  [STORAGE_KEYS.WATER_ENTRIES]: 'water_entries',
  [STORAGE_KEYS.ACTIVE_FASTING]: 'active_fasting',
  [STORAGE_KEYS.FAVORITE_FOODS]: 'favorite_foods',
  [STORAGE_KEYS.USER_SETTINGS]: 'user_settings'
};
